import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { SetUserField, UserForm } from "../usersPageHelpers";

export interface FormPanelProps {
  form: UserForm;
  setField: SetUserField;
  isMobile: boolean;
}

type KeysOfType<T> = { [K in keyof UserForm]: UserForm[K] extends T ? K : never }[keyof UserForm];

type FormTextFieldProps = Omit<TextFieldProps, "value" | "onChange"> & {
  form: UserForm;
  setField: SetUserField;
  field: KeysOfType<string>;
};

export function FormTextField({ form, setField, field, ...props }: FormTextFieldProps) {
  return (
    <TextField
      fullWidth
      size="small"
      {...props}
      value={form[field]}
      onChange={event => setField(field, event.target.value)}
    />
  );
}

interface FormSwitchProps {
  form: UserForm;
  setField: SetUserField;
  field: KeysOfType<boolean>;
  label: string;
}

export function FormSwitch({ form, setField, field, label }: FormSwitchProps) {
  return (
    <FormControlLabel
      control={
        <Switch checked={form[field]} onChange={event => setField(field, event.target.checked)} />
      }
      label={label}
    />
  );
}
